import { useNavigate } from 'react-router-dom';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import { SARLAFT_EDIT } from '../../../../../../routes/paths';
import EditIcon from '@mui/icons-material/Edit';
import { SarlaftDetailActionsProps } from './props';

export const SarlaftDetailActions = ({
    sarlaftId,
}: SarlaftDetailActionsProps) => {
    const navigate = useNavigate();
    const textBtnStyle = {
        display: {
            xs: 'none',
            lg: 'block',
        },
    };

    const btnIconStyle = { marginRight: { xs: -1, lg: undefined } };

    return (
        <>
            <LoadingButtonGeneral
                variant="outlined"
                title="Editar"
                sx={{ mr: 1 }}
                onClick={() => navigate(`${SARLAFT_EDIT}/${sarlaftId}`)}
                startIcon={<EditIcon sx={btnIconStyle} />}
                textSx={textBtnStyle}
            />
        </>
    );
};
